import { useEffect, useRef, useState } from "react";
import {
  Avatar,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";

export default function SuggestionList({ items, command, selectedIndex }: any) {
  const ref = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const el = ref.current?.children[selectedIndex] as HTMLElement;
    if (el) el.scrollIntoView({ block: "nearest" });
  }, [selectedIndex]);

  const getInitials = (name: string) =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  const getColor = (name: string) => {
    const colors = ["#3f51b5", "#f44336", "#4caf50", "#ff9800"];
    const hash = name
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  const UserAvatar = ({ item }: { item: any }) => {
    const [error, setError] = useState(false);

    if (item.avatar && !error) {
      return (
        <Avatar
          alt={item.label}
          src={item.avatar}
          onError={() => setError(true)}
        />
      );
    }

    return (
      <Avatar sx={{ bgcolor: getColor(item.label) }}>
        {getInitials(item.label)}
      </Avatar>
    );
  };

  return (
    <List
      ref={ref}
      sx={{
        position: "absolute",
        zIndex: 9999,
        width: 300,
        maxHeight: 240,
        overflowY: "auto",
        bgcolor: "background.paper",
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        boxShadow: 3,
        p: 0,
      }}
    >
      {items?.length > 0 &&
        items.map((item: any, index: number) => (
          <ListItemButton
            key={item.id}
            selected={index === selectedIndex}
            onClick={() => command(item)}
            sx={{
              gap: 1,
              px: 1,
              py: 1,
            }}
          >
            <ListItemAvatar>
              <UserAvatar item={item} />
            </ListItemAvatar>
            <ListItemText
              primary={item.fullName || item.label}
              primaryTypographyProps={{ fontSize: 14 }}
            />
          </ListItemButton>
        ))}
    </List>
  );
}
